import { render, staticRenderFns } from "./TransferFreeBonusFinancing.vue?vue&type=template&id=5fef8012&"
import script from "./TransferFreeBonusFinancing.vue?vue&type=script&lang=js&"
export * from "./TransferFreeBonusFinancing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports